import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import WrapperContent from "../../components/shared/WrapperContent";
import style from "./index.module.scss";
import { useSelector } from 'react-redux';
import ConfirmDocuments from '../../components/onboarding/confirm-documents/ConfirmDocuments';
import ConfirmEmail from '../../components/onboarding/confirm-email/ConfirmEmail';
import HeaderContentNew from '../../components/shared/HeaderContentNew/HeaderContentNew';
import VideoInstruction from '../../components/onboarding-expeditor/video-instruction/VideoInstruction';

const OnboardingExpeditorPage = () => {
    const { t } = useTranslation();
    const { user } = useSelector(state => state);

    const [isOpenEmail, setIsOpenEmail] = useState(true);
    const [isOpenDocuments, setIsOpenDocuments] = useState(false);
    const [isOpenInstruction, setIsOpenInstruction] = useState(false);

    const getPropsStep = () => ({
        user,
        isOpenEmail,
        setIsOpenEmail,
        isOpenDocuments,
        setIsOpenDocuments,
        isOpenInstruction,
        setIsOpenInstruction
    })

    return (
        <>
            <HeaderContentNew title={t('onboarding.pageTitle')} displayTitle displayReloadBtn={false} displayCreateBtn={false} />

            <div className={style.onboardingPage}>
                <div className={style.onboardingPage_content}>
                    <div className={style.greetingMessage}>
                        <div className={style.greetingMessage_title}>{t('onboarding.greetingTitle', { name: user.name })}</div>
                        <div className={style.greetingMessage_text}>{t('onboarding.greetingText')}</div>
                    </div>
                    <div className={style.onboardingPage_confirmCards}>
                        <ConfirmEmail {...getPropsStep()} />
                        <ConfirmDocuments {...getPropsStep()} />
                        <VideoInstruction {...getPropsStep()} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default OnboardingExpeditorPage;
